import { Fragment, useEffect, useState } from "react"
import { Menu, Transition } from "@headlessui/react"
import { HiOutlineGlobeAlt } from "react-icons/hi2"
import { useTranslation } from "react-i18next"
import { RiArrowDownSLine } from "react-icons/ri"

function classNames(...classes) {
  return classes.filter(Boolean).join(" ")
}

export const langs = [
  {
    id: 1,
    tittle: "Eng",
    code: "en",
  },
  {
    id: 2,
    tittle: "Ру",
    code: "ru",
  },
  {
    id: 3,
    tittle: "Uz",
    code: "uz",
  },
  {
    id: 4,
    tittle: "Уз",
    code: "уз",
  },
]

export default () => {
  const [activeLang, setActiveLang] = useState("uz")
  const { i18n, t } = useTranslation()
  const defaultLang = localStorage.getItem("lang")

  useEffect(() => {
    const defaultLang = localStorage.getItem("lang")
    setActiveLang(defaultLang)
  }, [])

  //Creating a method to change the language onChnage from select box
  const changeLanguageHandler = (lang) => {
    i18n.changeLanguage(lang)
    localStorage.setItem("lang", lang)
  }
  return (
    <Menu as="div" className="relative inline-block">
      <div>
        <Menu.Button className="flex w-full justify-center items-center h-10 rounded-[4px] text-[white] focus:outline-none ">
          <span className="text-base text-[white] capitalize">
            {defaultLang}
          </span>
          <RiArrowDownSLine
            className="pt-1"
            aria-hidden="true"
            color="white"
            size={24}
          />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 mt-2 w-[310px] origin-top-right bg-white focus:outline-none">
          <div className="py-1">
            <Menu.Item as="div">
              {({ active }) => (
                <div
                  className={classNames(
                    active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                    "flex justify-between items-center px-2 py-2 text-sm w-full"
                  )}
                >
                  <HiOutlineGlobeAlt
                    className="h-7 w-7 "
                    // aria-hidden="true"
                    color="#A5A5A5"
                  />
                  {t("select-lang")}
                  <div className="flex items-center justify-center gap-2">
                    {langs.map((item, indx) => (
                      <button
                        onClick={() => {
                          setActiveLang(() => item.code)
                          changeLanguageHandler(item.code)
                        }}
                        key={item.code}
                        className={classNames(
                          activeLang === item.code
                            ? "text-black"
                            : "text-disabled-text-color",
                          indx < 3 ? "after:content-['|'] after:ml-2" : "",
                          "font-medium text-base"
                        )}
                      >
                        {item.tittle}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}
